import { Grid, ListItemButton, ListItemText, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import dayjs from "dayjs";

const NoteListItemShort = ({ object, primaryClick }) => {
  return (
    <ListItemButton
      key={object.id}
      onClick={() => {
        primaryClick(object);
      }}
    >
      <ListItemText
        primary={object.subject}
        secondary={
          <>
            {object?.companies_detail[0] && (
              <>
                <Link
                  href={`/company/${object.companies_detail[0].id}`}
                  key={object.companies_detail[0]}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                >
                  {object.companies_detail[0].best_name}
                </Link>
                {object?.people[0] && " - "}
              </>
            )}
            {object?.people[0] && (
              <Link
                href={`/people/${object?.people[0].id}`}
                key={object?.people[0]}
                target="_blank"
                sx={{ mr: 1 }}
                onClick={(e) => e.stopPropagation()}
              >
                {object?.people[0].best_name}
              </Link>
            )}
          </>
        }
        slotProps={{
          secondary: {
            sx: {
              textOverflow: "hidden",
              noWrap: true,
            },
          },
          primary: {
            sx: {
              wordWrap: "break-word",
            },
          },
        }}
      />
      <Grid container direction="column" textAlign="end" sx={{ flex: "auto" }}>
        <Grid>
          <Typography variant="caption">
            {object?.owner_detail?.initials}
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="caption">
            {dayjs(object?.created_at).format("DD/MM/YYYY")}
          </Typography>
        </Grid>
      </Grid>
    </ListItemButton>
  );
};

export default NoteListItemShort;
